import { render, staticRenderFns } from "./Senha.vue?vue&type=template&id=11239513"
import script from "./Senha.vue?vue&type=script&lang=js"
export * from "./Senha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports